import { render } from "./searchSpeciesComponent.vue?vue&type=template&id=d85fd464&scoped=true"
import script from "./searchSpeciesComponent.vue?vue&type=script&lang=js"
export * from "./searchSpeciesComponent.vue?vue&type=script&lang=js"

import "./searchSpeciesComponent.vue?vue&type=style&index=0&id=d85fd464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85fd464"]])

export default __exports__